export default class CreateTechLibViewModel {
    public assetId: number = 0;
    public file: File | null = null;
    public fileName: string = '';
    public fileType: number = 0;
    public wseReferenceNumber: string = '';
    public liveWse: boolean = false;
    public approvalDate: Date = new Date();
}